import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addField } from "services";

import { ADD_FIELD, GET_FARMS, GET_FIELDS } from "consts";

export const useAddField = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [ADD_FIELD],
    mutationFn: addField,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FIELDS] });
      queryClient.invalidateQueries({ queryKey: [GET_FARMS] });
    },
  });
};
